<template>
  <div class="login-bg">
    <video
      class="bg-video"
      src="/myResource/login/login.mp4"
      autoplay
      loop
      muted
      playsinline
      poster="/myResource/login/login.jpg"
      style="filter: brightness(0.9) contrast(0.95);"
    ></video>
    <div class="bg-mask"></div>
    <section class="panel" v-animate="panelAnimation" @animationend="onPanelAnimationEnd">
      <!-- <button @click="testGetUserLocation">点击获取定位</button> -->
      <h1 class="main-title">
        I'm here for you
      </h1>
      <div class="login-box" v-animate="loginAnimation" @animationend="clearLoginAnimation">
        <div style="position:relative;z-index:1;">
          <template v-if="step === 1">
            <van-field
              v-model="code1"
              placeholder="你的名字"
              clearable
              label="口令"
              :border="false"
            />
            <van-button type="primary" block round @click="handleStepOne">下一步</van-button>
          </template>
          <template v-else>
            <van-field
              v-model="code2"
              placeholder="Ta的名字"
              clearable
              label="口令"
              :border="false"
            />
            <van-button type="primary" block round @click="handleStepTwo">进入纪念空间</van-button>
          </template>
        </div>
      </div>
    </section>
    <div class="icp-footer">
      <van-popup v-model="showUpdate" position="bottom" :style="{ height: '60%' }">
        <div class="update-log">
          <ul>
            <li>2025.07.08 ｜ 基础版本  v1.0.0</li>
            <li>2025.07.10 ｜ 测试版本  v1.5.1</li>
            <li>2025.07.21 ｜ 测试版本  v1.8.0</li>
            <li>2025.07.22 ｜ 测试版本  v2.0.0</li>
            <li>2025.07.23 ｜ 测试版本  v2.1.0</li>
            <li>2025.07.24 ｜ 基础版本  v2.2.0</li>
            <li>2025.08.23 ｜ 基础维护 🚧 </li>
            <li>2025.10.17 ｜ 基础维护 🚧 数据统计功能</li>
            <li>2025.12.02 ｜ 服务器维护 🚧 </li>
            <li>2026.01.01 ｜ 前端UI维护 🚧 </li>
          </ul>
        </div>
      </van-popup>
      <a class="icp-link" href="https://beian.miit.gov.cn/?site=brandsite&from=footer#/Integrated/index" target="_blank" rel="noopener">
        Copyright © 2025 Sodor Island 版权所有 皖ICP备2024037397号
      </a>
      <span class="icp-divider">|</span>
      <span class="icp-update-link" @click="showUpdate = true">版本更新</span>
    </div>
  </div>
</template>

<script>
import { verifyStepOne, verifyStepTwo } from '@/api/login'
import { setToken, removeToken } from '@/utils/token'
// import { getUserLocation } from '@/utils/location'

export default {
  name: 'LoginView',
  data () {
    return {
      code1: '',
      code2: '',
      step: 1, // 当前步骤
      loginAnimation: '',
      panelAnimation: '',
      pendingHome: false,
      tempCode: '', // 临时令牌，仅保存在data变量中
      showUpdate: false
    }
  },
  methods: {
    clearLoginAnimation () {
      this.loginAnimation = ''
    },
    onPanelAnimationEnd () {
      if (this.panelAnimation) {
        this.panelAnimation = ''
        // 只有在第二步校验通过时才跳转
        if (this.pendingHome) {
          this.pendingHome = false
          this.$router.replace({ name: 'home' })
        }
      }
    },
    // 第一步校验，成功后保存tempCode
    async handleStepOne () {
      if (!this.code1.trim()) {
        this.loginAnimation = 'shakeX'
        setTimeout(() => { this.loginAnimation = '' }, 800)
        this.$toast('你咋啥都不写呢？')
        return
      }
      try {
        const res = await verifyStepOne({ code: this.code1 })
        if (res.code === 200 && res.data && typeof res.data.tempCode === 'string' && res.data.tempCode.length > 0) {
          this.tempCode = res.data.tempCode // 只保存在data变量
          this.loginAnimation = 'bounceOut'
          setTimeout(() => {
            this.step = 2
            this.code2 = ''
            this.loginAnimation = 'zoomInUp'
          }, 500)
        } else {
          this.loginAnimation = 'shakeX'
          setTimeout(() => { this.loginAnimation = '' }, 800)
          this.$toast('不对哦～再想想')
        }
      } catch (e) {
        // 错误提示已由拦截器处理
      }
    },
    // 第二步校验，带上tempCode
    async handleStepTwo () {
      if (!this.code2.trim()) {
        this.loginAnimation = 'shakeX'
        setTimeout(() => { this.loginAnimation = '' }, 800)
        this.$toast('你忘记Ta的名字了?')
        return
      }
      try {
        const res = await verifyStepTwo({
          codeOne: this.code1,
          codeTwo: this.code2,
          tempCode: this.tempCode // 带上临时令牌
        })
        if (res && res.code === 200 && res.data && typeof res.data.token === 'string' && res.data.token.length > 0) {
          setToken(res.data.token) // 存储token
          if (res.data.userId) {
            localStorage.setItem('userId', res.data.userId)
          }
          if (res.data.nickname) {
            localStorage.setItem('nickname', res.data.nickname)
          }
          this.pendingHome = true
          // 第二步，整体box淡出
          this.panelAnimation = 'fadeOut'
          // getUserLocation()
        } else {
          this.loginAnimation = 'shakeX'
          setTimeout(() => { this.loginAnimation = '' }, 800)
          this.$toast('Ta的名字不对哦～')
        }
      } catch (e) {
        // 错误提示已由拦截器处理
      }
    },
    // 退出登录
    handleLogout () {
      removeToken()
      localStorage.removeItem('nickname')
      this.$router.replace({ name: 'login' })
    }
    // testGetUserLocation () {
    //   getUserLocation()
    // }
  }
}
</script>

<style scoped>
:root {
  --c-sky: #7FC8F8;
  --c-grass: #A8E38A;
  --c-cloud: #FDFDFD;
}
.login-bg {
  min-height: 96vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  overflow: hidden;
}
.bg-video {
  position: absolute;
  left: 0; top: 0;
  width: 100vw; height: 100vh;
  object-fit: cover;
  z-index: 0;
}
.bg-mask {
  position: absolute;
  left: 0; top: 0;
  width: 100vw; height: 100vh;
  background: rgba(255,255,255,0.18);
  z-index: 1;
  pointer-events: none;
}
.panel {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 85vw; max-width: 340px;
  padding: 32px 24px 28px 24px;
  background: rgba(255,255,255,0.02);
  backdrop-filter: blur(10px) saturate(120%);
  border-radius: 24px;
  box-shadow: 0 10px 24px rgba(0,0,0,0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  transition: transform 0.35s;
}
.main-title {
  font-family: 'Caveat', '小赖手写体', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 2.1rem;
  font-weight: 700;
  color: var(--c-grass);
  text-shadow: 0 3px 6px rgba(0,0,0,0.25);
  letter-spacing: .08em;
  text-align: center;
  margin-bottom: 0.5em;
  line-height: 1.2;
}
.subtitle {
  font-size: 1rem;
  color: var(--c-sky);
  opacity: 0.7;
  margin-top: 0.5em;
  font-weight: 400;
}
.login-box {
  width: 100%;
  padding: 0;
  background: none;
  box-shadow: none;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
}
::v-deep .van-field {
  background: var(--c-cloud);
  border-radius: 16px;
  border: 1px solid rgba(255,255,255,0.6);
  margin-bottom: 0;
  margin-top: 0;
  padding: 14px 18px;
  font-size: 16px;
  transition: border 0.2s, box-shadow 0.2s;
}
::v-deep .van-field + .van-field {
  margin-top: 16px;
}
::v-deep .van-field__control {
  color: #2F4F4F;
  font-size: 1rem;
  background: transparent;
}
::v-deep .van-field__label {
  color: var(--c-sky);
  font-weight: 600;
  letter-spacing: 1px;
}
::v-deep .van-field--focused {
  border: 1.5px solid var(--c-sky);
  box-shadow: 0 2px 12px rgba(127,200,248,0.10);
}
::v-deep .van-button {
  background: linear-gradient(135deg, var(--c-grass), var(--c-sky));
  border-radius: 20px;
  font-size: 1.15rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #fff;
  box-shadow: 0 2px 12px rgba(127,200,248,0.10);
  border: none;
  margin-top: 24px;
  transition: background 0.2s, box-shadow 0.2s, transform 0.1s;
}
::v-deep .van-button:active {
  background: linear-gradient(135deg, var(--c-sky), var(--c-grass));
  box-shadow: 0 4px 16px rgba(127,200,248,0.13);
  transform: scale(0.96);
}
@media (max-width: 600px) {
  .main-title {
    font-size: 1.5rem;
    margin-top: 0;
  }
  .panel {
    padding: 18px 8px 16px 8px;
    max-width: 98vw;
  }
}
.icp-footer {
  position: absolute;
  bottom: 2px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #b0b0b0;
  z-index: 3;
  user-select: none;
  white-space: nowrap;         /* 不换行 */
  overflow: hidden;            /* 超出隐藏 */
  text-overflow: ellipsis;     /* 超出显示省略号 */
  line-height: 1.7;
  padding: 0 8px;
}
.icp-link,
.icp-update-link,
.icp-divider {
  display: inline;
  vertical-align: middle;
  font-size: 10px;
}
.icp-link,
.icp-link:visited,
.icp-link:hover,
.icp-link:active,
.icp-link:focus {
  color: #b0b0b0;
  text-decoration: none;
  background: none;
  outline: none;
  box-shadow: none;
  cursor: pointer;
  font-size: 10px;
}
.icp-divider {
  margin: 0 4px;
  color: #b0b0b0;
}
.icp-update-link {
  color: #7FC8F8;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.2s;
  white-space: nowrap;
}
.icp-update-link:hover {
  color: #409EFF;
}
@media (max-width: 400px) {
  .icp-footer {
    font-size: 11px;
    flex-direction: column;
    gap: 0;
    line-height: 1.5;
  }
  .icp-divider {
    display: none;
  }
}
.update-log {
  padding: 20px 16px;
  font-size: 15px;
  color: #333;
}
.update-log h3 {
  margin: 0 0 12px 0;
  font-size: 17px;
  color: #7FC8F8;
}
.update-log ul {
  padding-left: 18px;
  margin: 0;
}
</style>
